import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";

const blocks = () => {

  const CFG = {
    cardStagger: 0.12,
    ease:        'power3.out',
    start:       'top 82%',
    blockDelay:  0.3,
    blur: { card: '12px', icon: '6px', title: '5px', intro: '4px', cta: '3px' },
    y:    { card: 24,     icon: 12,    title: 10,    intro: 8,     cta: 6      },
    t:    { card: 0.85,   icon: 0.65,  title: 0.75,  intro: 0.70,  cta: 0.45  },
  };

  function setInitialStates() {
    document.querySelectorAll('.servizio-card').forEach(card => {
      const icon  = card.querySelector('.servizio-icon');
      const title = card.querySelector('.title-text');
      const intro = card.querySelector('.servizio-intro');
      const cta   = card.querySelector('.servizio-cta');

      

      gsap.set(card,  { opacity: 0, y: CFG.y.card,  filter: `blur(${CFG.blur.card})`  });
      if (icon)  gsap.set(icon,  { opacity: 0, y: CFG.y.icon,  filter: `blur(${CFG.blur.icon})`  });
      if (title) gsap.set(title, { opacity: 0, y: CFG.y.title, filter: `blur(${CFG.blur.title})` });
      if (intro) gsap.set(intro, { opacity: 0, y: CFG.y.intro, filter: `blur(${CFG.blur.intro})` });
      if (cta)   gsap.set(cta,   { opacity: 0, y: CFG.y.cta,   filter: `blur(${CFG.blur.cta})`   });
    });
  }

  function initServizi() {
    if (!document.querySelector('.servizio-card')) return;

    gsap.utils.toArray('.servizio-card').forEach((card, i) => {
      const icon   = card.querySelector('.servizio-icon');
      const title  = card.querySelector('.title-text');
      const intro  = card.querySelector('.servizio-intro');
      const cta    = card.querySelector('.servizio-cta');
      const dScale = parseFloat(card.dataset.duration || 1);

      

      const tl = gsap.timeline({
        delay: CFG.blockDelay + (i * CFG.cardStagger),
        scrollTrigger: { trigger: card, start: CFG.start, once: true },
        defaults: { ease: CFG.ease, clearProps: 'filter' },
      });

      tl.to(card,  { opacity: 1, y: 0, filter: 'blur(0px)', duration: CFG.t.card  * dScale });
      if (icon)  tl.to(icon,  { opacity: 1, y: 0, filter: 'blur(0px)', duration: CFG.t.icon  * dScale }, '<0.08');
      if (title) tl.to(title, { opacity: 1, y: 0, filter: 'blur(0px)', duration: CFG.t.title * dScale }, '<0.1' );
      if (intro) tl.to(intro, { opacity: 1, y: 0, filter: 'blur(0px)', duration: CFG.t.intro * dScale }, '<0.12');
      if (cta)   tl.to(cta,   { opacity: 1, y: 0, filter: 'blur(0px)', duration: CFG.t.cta   * dScale }, '<0.15');
    });

    // ── Parallax icone ──────────────────────────────────
    // Doppio rAF — aspetta che il layout sia completamente
    // stabile prima che ScrollTrigger calcoli start/end
    const serviziPreview = document.querySelector('.servizi-preview');
    const servizioIcons  = document.querySelectorAll('.servizio-icon');

    if (serviziPreview && servizioIcons.length) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          gsap.to(servizioIcons, {
            y:    -16,
            ease: 'none',
            scrollTrigger: {
              trigger: serviziPreview,
              start:   'top bottom',
              end:     'bottom top',
              scrub:   true,
            },
          });
        });
      });
    }
  }

  setInitialStates();

  if (document.readyState === 'complete') {
    initServizi();
  } else {
    window.addEventListener('load', initServizi);
  }

};

export default blocks;